<div>
  <ng-template libCustomHost></ng-template>
</div>
<div class="row concept-detail-list" *ngIf="product?.subProductIds && product?.subProductIds.length > 0 && showConceptDetails">
  <div class="col-12">
    <lib-filter-list #conceptList [configService]="configService"></lib-filter-list>
  </div>
</div>
